<template>
  <div>
    <div id="container"></div>
    <div :class="['rightpanel',citycode ? 'hide' : '']">
      <!-- <div class="dd-panel">
        <div class="dd-paneltitle">
          <span></span>
          <span>客户概览</span>
          <span></span>
        </div>
        <div class="dd-panelbody box-body">
          <div style="margin-top: 30px">
            <div class="box-body-label">VIP&nbsp;&nbsp;客户</div>
            <div class="box-body-value"
              :style="{ 'width': (homedatainfo.xiaoqugk.vipcount / (homedatainfo.xiaoqugk.allcount == 0 ? 1 : homedatainfo.xiaoqugk.allcount) * 200 + 40) + 'px' }">
              <div clas="">
                <span>{{ homedatainfo.xiaoqugk.vipcount }}所</span>
              </div>
            </div>
          </div>
          <div>
            <div class="box-body-label">独家客户</div>
            <div class="box-body-value"
              :style="{ 'width': (homedatainfo.xiaoqugk.djcount / (homedatainfo.xiaoqugk.allcount == 0 ? 1 : homedatainfo.xiaoqugk.allcount) * 200 + 40) + 'px' }">
              <div clas="">
                <span>{{ homedatainfo.xiaoqugk.djcount }}所</span>
              </div>
            </div>
          </div>
          <div>
            <div class="box-body-label shout">普通客户</div>
            <div class="box-body-value"
              :style="{ 'width': (homedatainfo.xiaoqugk.ptcount / (homedatainfo.xiaoqugk.allcount == 0 ? 1 : homedatainfo.xiaoqugk.allcount) * 200 + 40) + 'px' }">
              <div clas="">
                <span>{{ homedatainfo.xiaoqugk.ptcount }}所</span>
              </div>
            </div>
          </div>
          <div>
            <div class="box-body-label shout">&nbsp;合&nbsp;&nbsp;&nbsp;伙&nbsp;&nbsp;&nbsp;人&nbsp;</div>
            <div class="box-body-value"
              :style="{ 'width': (homedatainfo.xiaoqugk.hhrcount / (homedatainfo.xiaoqugk.allcount == 0 ? 1 : homedatainfo.xiaoqugk.allcount) * 200 + 40) + 'px' }">
              <div clas="">
                <span>{{ homedatainfo.xiaoqugk.hhrcount }}所</span>
              </div>

            </div>
          </div>
        </div>
        <div class="dd-panelfoot">
          <span></span>
        </div>
      </div> -->
      <!-- <div class="dd-panel">
        <div class="dd-paneltitle dd-autoweigth">
          <span></span>
          <span id="autotext"> </span>
          <span v-if="showspan" :style="autowidth"></span>
        </div>
        <div class="dd-panelbody">
          <div class="box-body-charts">
            <div id="myChart" :style="{ width: '100%', height: '190px' }"></div>
          </div>
        </div>
        <div class="dd-panelfoot">
          <span></span>
        </div>
      </div> -->
      <div class="dd-panel">
        <div class="dd-paneltitle">
          <span></span>
          <span>最新签约</span>
          <span></span>
        </div>
        <div class="dd-panelbody" style="height: 500px;overflow: hidden;">
          <div class="dd-rili">
            <vue-seamless-scroll :key="timeKey" :data="homedatainfo.zxqylist" :class-option="scrollOption" class="info">
              <ul class="qianyuelist">
                <li v-for="(item, index) in homedatainfo.zxqylist">{{ item.htksrq }} {{ item.name }}</li>

              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
        <div class="dd-panelfoot">
          <span></span>
        </div>
      </div>
    </div>
    <div :class="['showpanel', citycode ? 'show' : '']">
      <img @click="closeMode" src="../assets/closeicon.png" />
      <div class="showpaneltitle">{{ cityname }}客户列表</div>
      <div class="showpanelbody">
        <dl>
          <dd  @click="selectxiaoqu(item)" v-for="(item, index) in cityschoollist" :key="item.index">
            {{ item.xian }} - {{ item.schoolname }} {{item.daoqi}}
          </dd>
        </dl>
      </div>
    </div>

    <!-- <div :class="['showleftdeviceinfo', selsctschool.schoolname ? 'show' : '']">

      <div class="qiyetitle">
        客户详细信息
      </div>
      <div class="shebeilist">
          <div class="shebeiinfo">
          <ul>
            <li><span>客户名称：</span>
              {{ selsctschool.schoolname }}</li>
            <li><span>客户地址：</span>{{ selsctschool.addr }}</li>
            <li><span>客户类型：</span>{{ selsctschool.typedesc }}</li>
            <li><span>保护类型：</span>{{ selsctschool.areatypedesc }}</li>
            <li><span>保护截至时间：</span>{{ selsctschool.daoqirq }}</li>
            <li><span>所属行政区划：</span>{{ selsctschool.sheng }}-{{ selsctschool.shi }}-{{ selsctschool.xian }}</li>
          </ul>
        </div>
      </div>

    </div> -->

    <div :class="['showleftsearinfo',    'show1']">
      <el-input style="width: 300px;" v-model="keyword" prefix-icon="el-icon-search" @keyup.native.enter="searchKeyword"
                      placeholder="请输入地址信息进行搜索..."></el-input>
      <a type="button" @click="searchKeyword">搜索</a>
    </div>
  </div>
</template>
<script>
import { getcityschools, homeinfo } from '../api/api'
export default {
  data() {
    return {
       
      autowidth: "width:calc(100% - 6.1vw);",
      showspan: true,
      changjialist: [],

      selectsheng: "",
      openshengf: [],

      riqilist: [],
      errlist: [],
      showerrlist: [],
      today: 0,
      map: null,
      disProvince: null,
      zhongxin: [110.804, 39.606],
      shengfentongji: [],
      shebeiinfo: {
        allcount: 0,
        runcount: 0,
        lixiancount: 0,
        guzhangcount: 0
      },
      qiyeshebei: [],
      showqiyeshebei: false,
      getqiyeinfotimer: null,

      homedatainfo: {
        xiaoqugk: {},
        zxqylist: [],
        shengfen: []
      },
      timeKey: '1234',
      cityschoollist: [],
      cityname: null,
      citycode: null,
      selsctschool: {},
      keyword:'',
      placeSearch :null

    };
  },
  created() {


    let that = this;

    homeinfo().then(res => {
      that.loadmap();
      that.homedatainfo = res.data;
      that.initPro(res.data.shengfen, 1);
      that.circlemark(res.data.showschoollist);
    })

  },
  destroyed() {

  },
  methods: {


    showdangbzw() {
      // let divc = document.getElementById('myChart');
      // divc.innerHTML = '';

      let myChart = this.$echarts.init(document.getElementById("myChart"));

      let option = {
        tooltip: {
          trigger: "item",
        },
        color: [
          "#8256e9",
          "#eb6f49",
          "#00d98b",
          "#fdb626",
          "#00e4ed",
          "#5e97e6",
          "#43a923",
        ],
        legend: {
          textStyle: {
            color: "#fff",
          },
          type: "scroll",
          align: "left",
          orient: "vertical",
          right: "0%",
        },

        series: [
          {
            name: "设备分布",
            type: "pie",
            center: ["30%", "50%"],
            radius: ["40%", "80%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },

            labelLine: {
              show: false,
            },
            data: this.shengfentongji,
          },
        ],
      };

      // 绘制图表
      myChart.setOption(option);
    },
    initPro(code, dep) {
      let that = this;
      dep = typeof dep == 'undefined' ? 0 : dep;


      that.disProvince && that.disProvince.setMap(null);

      that.disProvince = new AMap.DistrictLayer.Province({
        zIndex: 12,
        adcode: code,
        depth: dep,
        styles: {
          'fill': 'rgba(0,125,215,0.15)',
          //'province-stroke': 'cornflowerblue',
          //'city-stroke': 'white', // 中国地级市边界
          //'county-stroke': 'rgba(255,255,255,0.5)' // 中国区县边界
        }
      });

      that.disProvince.setMap(that.map);
    },
    closeMode() {
      this.map.setCenter(this.zhongxin);
      this.map.setZoom(5);
      this.citycode = null;
      this.selsctschool= {};
    },
    loadmap() {
      let that = this;
      that.map = new AMap.Map('container', {
        zoom: 5,//级别
        center: that.zhongxin,//中心点坐标
        mapStyle: 'amap://styles/a1957ab716e8374961906fd797442322',

      });

      that.map.on("click", function (e) {
        console.log("地图点击事件：");
        const ccode = e.citycode;
        let lnglat = [e.lnglat.lng, e.lnglat.lat];
        let geocoder = new AMap.Geocoder({ radius: 1000 });
        geocoder.getAddress(lnglat, (status, result) => {
          if (status === "complete" && result.regeocode && (that.citycode == null || ccode != that.citycode )) {
            console.log(result.regeocode.addressComponent);
            let adcode = result.regeocode.addressComponent.adcode;
            adcode = parseInt(adcode.substring(0, 4) + "00");
            if (that.homedatainfo.shengfen.indexOf(adcode) > -1) {
              that.map.setCenter(lnglat);
              that.map.setZoom(9);
              that.citycode = adcode;
              that.cityname = result.regeocode.addressComponent.city;
              //  that.getfenshengdata(shengf);
              that.getcityinfo(adcode);
            }
          }
        });

      })
    },

    getcityinfo(code) {
      let that = this;
      getcityschools({ code: code }).then(res => {
        console.log(res);
        that.cityschoollist = res.data;
      })
    },
    circlemark(list) {
      let that = this;
      
      list.forEach(item => {
        console.log(item)
        if (item.areatype != 1 && item.areatype != 9) {
          //画圆圈
          let banjing = 2000;
          switch(item.areatype){
            case 2:
              banjing = 2000;
              break;
              case 3:
              banjing = 1500;
              break;
              case 4:
              banjing = 1000;
              break;
              case 5:
              banjing = 500;
              break;
              case 6:
              banjing = 250;
              break;
              case 7:
              banjing = 175;
              break;
              case 8:
              banjing = 30;
              break;
          }
          const json = {
            radius:banjing,
            zIndex:9999,
            fillColor:'#f4433640',
            strokeColor:'#f44336',
            center:[item.jingdu,item.weidu]
          }
          let circle =  new AMap.Circle(json);
          that.map.add(circle);

        } else {
          //标记市县级区域
          let code = item.xiancode;
          if(item.areatype == 9){
            code = item.shicode;
          }
          let disProvince = new AMap.DistrictLayer.Province({
            zIndex: 12,
            adcode: code,
            depth: 2,
            styles: {
              'fill': '#f4433640',
            }
          });
          disProvince.setMap(that.map);
        }

        const schoolmarker = new AMap.Marker({
            map: that.map,
            draggable:false,
            title:`${item.schoolname} ${item.typedesc} ${item.daoqi}`,
            label:{
              content:`${item.schoolname} ${item.typedesc}`,
              direction:'center',
              offset:20
            },
            position: new AMap.LngLat(item.jingdu,item.weidu),
            zooms:[7,16],
            topWhenClick:true,
            extData:item.id
        });

        schoolmarker.on("click",(e)=>{
          console.log(e);
        })

      });
    },
    selectxiaoqu(item){
     
      this.map.setCenter([item.jingdu,item.weidu]);
      this.map.setZoom(15);
      //this.selsctschool = item;
    },
    searchKeyword(){
      let that = this;
    
      if(!this.keyword){
        this.$message({
                message: "请输入查询地址信息...",
                type: "error"
              });
        return false;
      }

      AMap.plugin('AMap.PlaceSearch', function () {
        let autoOptions = {
          city: "全国",
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码

          citylimit: true,  //是否强制限制在设置的城市内搜索
          map: that.map, // 展现结果的地图实例
          
          autoFitView: true // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
        }
        if(that.placeSearch == null){
          that.placeSearch = new AMap.PlaceSearch(autoOptions);
        }
         
        that.placeSearch.search(that.keyword, function (status, result) {
          console.log(result);
        });
 
        // AMap.event.addListener(placeSearch, "selectChanged", (res) => {
        //   that.markerfun(res);
        // }); //返回结果

        // AMap.event.addListener(placeSearch, "markerClick", (e)=>{
        //   // console.log("markerClick");
        //   // e.marker.setDraggable(true);
        // }); //返回结果

      })
    }
  },
  mounted() {



  },
  computed: {
    scrollOption() {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: 6, // 开始无缝滚动的数据量 this.list.length+1
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 50, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 2500 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
};
</script>
<style scoped>
#container {
  overflow: hidden;
  width: 100%;
  height: 100vh;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
}

.rightpanel,
.showpanel {
  position: absolute;
  z-index: 990;
  right: 20px;
  color: #fff;
}

.rightpanel{
  transition: all 1s;
}

.rightpanel.hide{
  right: -600px;
}

.showpanel {
  display: none;
}

.showpanel.show {
  display: block;
}

.dd-panel {
  width: 370px;
  margin-top: 10px;
}

.dd-panel .dd-paneltitle>span {
  vertical-align: middle;
  display: inline-block;
  font-size: 16px;
}

.dd-panel .dd-paneltitle>span:first-child {
  width: 18px;
  height: 18px;
  margin-right: 10px;
  background: #26c0fc;
}

.dd-panel .dd-paneltitle {
  line-height: 30px;
  height: 30px;
}

.dd-panel .dd-paneltitle::after {
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 5px;
  background: #26c0fc;
  content: " ";
}

.dd-panel .dd-paneltitle>span:nth-child(3) {
  width: 253px;
  border-bottom: 1px solid #26c0fc;
  margin: 0 10px;
}

.dd-panel .dd-panelbody {
  width: 100%;
  height: 200px;
  background: #052f4ac9;
  margin-top: 10px;
}

.dd-panel .dd-panelfoot {
  line-height: 30px;
  height: 30px;
}

.dd-panel .dd-panelfoot::after {
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 5px;
  background: #26c0fc;
  content: " ";
}

.dd-panel .dd-panelfoot::before {
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 5px;
  background: #26c0fc;
  content: " ";
}

.dd-panel .dd-panelfoot>span {
  margin: 0 10px;
  border-bottom: 1px solid #26c0fc;
  width: 340px;
  display: inline-block;
  vertical-align: middle;
}

.showpanel {
  right: 100px;
  bottom: 20px;
  position: fixed;
  background: #052f4ac9;
  height: 400px;
  width: 250px;
  border: 1px solid #26c0fc;
}

.showpanel>img {
  position: absolute;
  width: 36px;
  right: 0;
  margin-top: -30px;
  margin-right: -30px;
  cursor: pointer;
}

.showpanel>img:hover {
  animation: whirl 2s linear infinite;
}

@keyframes whirl {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.showpanel .showpaneltitle {
  color: #ddd;
  text-align: center;
  line-height: 50px;
  height: 50px;
  border-bottom: 1px solid #26c0fc;
  font-size: 16px;
}

.showpanel .showpanelbody {
  padding: 10px;
}

.showpanel .showpanelbody dl {
  margin: 0;
}

.showpanel .showpanelbody dd {
  margin-left: 0px;
  font-size: 14px;
  color: #27c1fd;
  cursor: pointer;
}

.showpanel .showpanelbody dd:hover {
  opacity: 0.8;
}

.showpanel .showpanelbody dd+dd {
  margin-top: 15px;
}

.box-body>div {
  margin-left: 20px;
}

.box-body .box-body-label {
  display: inline-block;
  padding-right: 20px;
  font-size: 14px;
  width: 60px;
}

.box-body .box-body-label.shout>span {
  letter-spacing: 28px;
}

.box-body .box-body-value {
  display: inline-block;
  width: calc(100% - 110px);
}

.box-body .box-body-value>div {
  height: 12px;
  background: linear-gradient(to right, #00bdf5, #006afe);
}

.box-body-value>div>span {
  margin-top: -25px;
  float: right;
  font-size: 14px;
}

.box-body>div+div {
  margin-top: 30px;
}

.box-body {
  overflow-y: hidden;
}

.box-body-charts {
  padding-top: 20px;
}

.showleftdeviceinfo {
  left: -500px;
  top: 20px;
  height: calc(100vh - 40px);
  width: 350px;
  background: #052f4ac9;
  position: fixed;
  bottom: auto;
  border: 1px solid #26c0fc;
  transition: all 1s;
}

.showleftdeviceinfo.show {
  left: 20px;
}

.showleftsearinfo{
  left: -500px;
  top: 60px;
  height: 40px;
  width: 360px;
  background: #052f4ac9;
  position: fixed;
  bottom: auto;
  border: 1px solid #26c0fc;
  transition: all 1s;
}

.showleftsearinfo.show.show1{
  left: 390px;
  top: 120px;
}

.showleftsearinfo.show1{
  left: 20px;
}

.showleftsearinfo>a{
  display: inline-block;
  height: 40px;
  line-height: 40px;
  color: #fff;
  text-align: center;
  width: 59px;
  border:none;
  border-left: 1px solid #26c0fc;
  cursor: pointer;
  background-color: #006afeaf;
  user-select: none;
  font-size: 18px;
  
}

.qiyetitle {
  color: #fff;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  padding-left: 20px;
  border-bottom: 1px solid #26c0fc;
}

.shebeilist {
  height: calc(100vh - 80px);
  overflow-x: hidden;
  overflow-y: auto;
  color: #fff;
  /* padding: 20px; */
  font-size: 15px;
}

.shebeilist>.shebeiinfo {
  padding: 15px;

}

.shebeilist>.shebeiinfo {

  border-bottom: 1px dashed #26c0fc;
}

.shebeilist>.shebeiinfo>ul>li>span {
  color: #bbb;
}

.shebeilist>.shebeiinfo>ul>li {
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.xuhao {
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  border-top: 35px solid #26c0fc;
  border-right: 35px solid transparent;
  margin-left: -15px;
  margin-top: -15px;
}

.xuhao>i {
  margin-top: -28px;
  position: absolute;
  /* margin-left: 2px; */
  font-size: 16px;
}

.qianyuelist>li {
  font-size: 16px;
  height: 50px;
  line-height: 50px;
  padding-left: 10px;
  border-bottom: 1px dotted #26c0fc;
}

.qianyuelist>:nth-child(2n) {
  background-color: #2089a1c9;
  color: #82fc26;
}

</style>